module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Spoon-c002287738c07da1921ce44253c1db5e.svg";